<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentcolor">
    <path d="M15.6 7H13.3V5H19V10.7H17V8.4L6.4 19L5 17.6L15.6 7Z" />
  </svg>
</template>

<script>
export default {};
</script>
